import React from "react";
import moment from "moment";
import {useFetch} from "../../../../../hooks/useFetch";
import {useStore} from "../../../../../hooks/useStore";
import {Button, Modal, Table, Tooltip} from "antd";

export const DocumentRejectHistoryModal = ({title, visible, onClose, courierId, documentType}) => {
    const stores = useStore();
    const [rejectHistoryLoading, rejectHistoryResult] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.courierStore.getCourierDocumentsRejectHistory.bind(null, {
            courierId,
            documentType
        }),
        dependencies: [courierId, documentType],
        initialCall: Boolean(courierId) && Boolean(documentType),
        condition: Boolean(courierId) && Boolean(documentType) && visible
    });

    return (
        <Modal
            title={title}
            visible={visible}
            onCancel={onClose}
            okText="Kapat"
            onOk={onClose}
            width={"auto"}
            style={{maxWidth: "800px"}}
            cancelButtonProps={{style: {display: "none"}}}
        >
            <Table
                size="small"
                dataSource={rejectHistoryResult?.rejectHistory}
                locale={{
                    emptyText: "Reddedilmiş dosya kaydı bulunamadı"
                }}
                columns={[
                    {
                        title: "Link",
                        dataIndex: ["file", "publicUrl"],
                        key: "file.publicUrl",
                        render: url =>
                            url ? (
                                <Tooltip title={"Belgeyi Görüntüle"}>
                                    <Button
                                        type="primary"
                                        onClick={() => window.open(url)}
                                        size="small"
                                    >
                                        Görüntüle
                                    </Button>
                                </Tooltip>
                            ) : (
                                "-"
                            )
                    },
                    {
                        title: "Reddetme Sebebi",
                        dataIndex: "reason",
                        key: "reason"
                    },
                    {
                        title: "Reddeden",
                        dataIndex: ["createdBy", "fullName"],
                        key: ["createdBy", "fullName"]
                    },
                    {
                        title: "Yüklenme Tarihi",
                        dataIndex: ["document", "createdAt"],
                        key: "document.createdAt",
                        render: date => moment(date).format("DD/MM/YYYY HH:mm")
                    },
                    {
                        title: "Reddedilme Tarih",
                        dataIndex: "createdAt",
                        key: "createdAt",
                        render: date => moment(date).format("DD/MM/YYYY HH:mm")
                    }
                ]}
                loading={rejectHistoryLoading}
            />
        </Modal>
    );
};
